import React from 'react'
import Feature from 'components/Feature'

export default Component => props => (
  <Feature
    render={({ feature }) => <Component feature={feature} {...props} />}
  />
)



// WEBPACK FOOTER //
// ./src/components/withFeature.js